import { render, staticRenderFns } from "./TopInfo.vue?vue&type=template&id=4f8abbfd&scoped=true&"
import script from "./TopInfo.vue?vue&type=script&lang=js&"
export * from "./TopInfo.vue?vue&type=script&lang=js&"
import style0 from "./TopInfo.vue?vue&type=style&index=0&id=4f8abbfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8abbfd",
  null
  
)

export default component.exports